import React from 'react';
import {t, Trans} from '@lingui/macro';

export const NumberUsedInfo = {
    title: () => t`Number Used`,
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.recreate_number_confirm = true;
        newAction.request.number = null;
        handleOk(newAction);
    },
    noPasscode: true,
};

function NumberUsed(props) {
    const { message } = props;
    return (
        <span>
            <p>
                {message}
            </p>
            <p>
                <Trans>Do you want to proceed with the next running number?</Trans>
            </p>
        </span>
    );
}

export default NumberUsed;
